import React from 'react';
import { BLOCKS, Block, Inline } from '@contentful/rich-text-types';

import { IInfoBlockFields } from '../../../types/contentful';

import RichText from '../RichText';
import { ScrollReveal } from '../ScrollReveal';
import GlImage from '../Image';

import { getImageData } from 'src/utils/contentful';
import { Asset } from 'contentful';

export function InfoBlock({
  headingText,
  centerAlign,
  bodyCopy,
  upperLeftIcon,
  optionalBackgroundColor
}: IInfoBlockFields) {
  const textAlign = centerAlign ? 'text-center' : 'text-left';
  const bgColor = optionalBackgroundColor
    ? `#${optionalBackgroundColor}`
    : '#035C67';

  return (
    <ScrollReveal>
      <div
        className="block-container mt-12 mb-12 mobile:mt-2 mobile:mb-1 tablet:mt-16 tablet:mb-16"
        data-blockid="infoBlock"
        data-testid="infoBlock"
      >
        <div className="flex flex-wrap flex-1 justify-center items-center box-border w-full">
          <div
            className="w-full h-full p-0 rounded-[56px] tablet:rounded-[64px] desktop:rounded-[104px] px-2 tablet:px-2 tablet:mx-8"
            style={{ backgroundColor: bgColor }}
          >
            {upperLeftIcon && (
              <GlImage
                {...getImageData(upperLeftIcon as Asset)}
                className="!h-auto max-w-[120px] mt-[25px] mr-[105px] min-[375px]:mr-[165px] min-[425px]:mr-[220px] tablet:mt-[35px] tablet:mr-[475px] desktop:mt-[35px] desktop:mr-[690px]"
              />
            )}
            <div className="box-column w-full">
              <div
                className={`flex flex-col-reverse tablet:flex-row tablet:flex-nowrap px-2 mx-auto tablet:max-w-[880px] items-center ${textAlign}`}
              >
                <div
                  className={`w-full tablet:w-auto tablet:mx-auto tablet:pt-10 tablet:pb-10 p-8 ${textAlign}`}
                >
                  <div className="mb-4 desktop:mb-12">
                    <h2 className="font-medium text-[28px] leading-8 desktop:text-[42px] desktop:leading-12 text-white">
                      {headingText}
                    </h2>
                  </div>
                  {bodyCopy && (
                    <div className="mb-6">
                      <RichText
                        data={bodyCopy}
                        colour="white"
                        bulletColor="green"
                        overrideOptions={{
                          [BLOCKS.LIST_ITEM]: (
                            node: Block | Inline,
                            children: any
                          ) => (
                            <li className="pl-[10px] [&>p]:text-xs [&>p]:font-normal [&>p]:mb-[15px] tablet:[&>p]:text-xl tablet:[&>p]:mb-[25px]">
                              {children}
                            </li>
                          )
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ScrollReveal>
  );
}
